import { IUseGetMyOwnTractorsParams } from '../../../hooks/api/user/queries/useGetMyOwnTractors';
import { IMyOwnTractor } from '../../../interfaces/OwnTractor.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

export const myOwnTractorsApiUrl = '/users-own-tractors/mine';

type IGetMyOwnTractorsParams = Pick<IUseGetMyOwnTractorsParams, 'searchParam'>;

export const getMyOwnTractors = ({ searchParam }: IGetMyOwnTractorsParams): Promise<IMyOwnTractor[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`${myOwnTractorsApiUrl}?${URLSearchParams}`);
};
